import { useAtomValue, getDefaultStore } from "jotai";
import { UserSettings } from "../../shared/types";
import { appLocalStore } from "./services";
import { userSettingsAtom } from "./atoms";

/**
 * This function is used to update the user data in the local state and send it to the service worker.
 */
export const upsertUserSettings = (newData: Partial<UserSettings>) => {
  getDefaultStore().set(userSettingsAtom, (userSettings: UserSettings) => {
    const newUserSettings = { ...userSettings, ...newData };
    appLocalStore.upsertUserSettings(newUserSettings);
    return newUserSettings;
  });
};

/**
 * This hook is used to get the user data from the local state.
 */
export const useUserSettings = () => {
  return useAtomValue(userSettingsAtom);
};

export const getUserSettings = () => {
  return getDefaultStore().get(userSettingsAtom);
};
